import { clsx } from "clsx";
import type { CSSProperties, ReactNode, RefObject } from "react";
import type { AriaListBoxProps } from "react-aria";
import { useListState } from "react-stately";

import { ListBox } from "../List/ListBox.tsx";
import { VStack } from "../Stack/VStack.tsx";
import style from "./SelectList.module.css";

export interface SelectListProps<T> extends AriaListBoxProps<T> {
  listBoxRef?: RefObject<HTMLDivElement>; // TODO, forwardRef! Needed ?
  className?: string;
  style?: CSSProperties;
  noBorder?: boolean;
}

export const SelectList = <T extends object>(props: SelectListProps<T>): ReactNode => {
  const state = useListState(props);

  return (
    <VStack
      spacing={2}
      // className={clsx({ [style.disabled]: !!props.isDisabled })}
      style={props.style}
      data-testid="text-field"
    >
      <ListBox
        {...props}
        state={state}
        listBoxRef={props.listBoxRef}
        className={clsx(style.list, { [style.with_border]: props.noBorder !== true })}
        style={props.style}
        showLabel
      />
    </VStack>
  );
};
